<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <p></p>
        <span>Débito Veicular</span>
        <p></p>
      </div>
      <div class="content">
        <div class="center">
          <div class="icon">
            <div class="inner-icon">
              <img :src="require('@/assets/svg/maquina.svg')" />
            </div>
          </div>
          <p>Para efetuar o pagamento, siga as instruções na maquininha...</p>
        </div>
      </div>
      <FooterGlobal />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import icNext from '@/assets/svg/ic-next.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icBack from '@/assets/svg/ic-back.svg'
import FooterGlobal from '@/components/Footer.vue'
import { saveTransaction } from '@/pinpad/debito'
import { openSupportTask } from '@/observability/observability'
import { pinpadUrl } from '@/helper/vars'
import axios from 'axios'

export default defineComponent({
  name: 'PagamentoDebitoVeicularCartao',
  components: {
    FooterGlobal,
  },
  data() {
    return {
      next: icNext,
      icClose: icClose,
      icBack: icBack,
      selectedOptions: [],
    }
  },
  async mounted() {
    const router = this.$router
    const urlpinpad = process.env.VUE_APP_PINPAD_API_URL

    try {
      // 1) Parcela selecionada
      const installmentId = sessionStorage.getItem('installmentSelect')
      const rawParcelas = sessionStorage.getItem('dadosParcelas')
      const listaParcelas = rawParcelas ? JSON.parse(rawParcelas) : []
      const arrayParcelas = Array.isArray(listaParcelas)
        ? listaParcelas
        : listaParcelas?.dados || []

      const parcela = arrayParcelas.find(
        (p) => String(p.numParcelas) === String(installmentId),
      )

      if (!parcela) {
        console.error('Parcela não encontrada:', installmentId)
        router.push('/home')
        return
      }

      const payload = {
        valor: parseInt(parcela.totalParcela * 100, 10),
        tipoPagamento: 'CREDITO',
        numParcelas: parseInt(parcela.numParcelas, 10),
      }

      console.log('Payload Pinpad (débito veicular):', payload)

      const config = {
        method: 'POST',
        url: `${urlpinpad}${pinpadUrl}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
      }

      let purchase = {}

      // 3) Chamada ao pinpad
      try {
        const response = await axios(config)
        purchase = response.data
        console.log('purchase', purchase)

        if (purchase.sucesso === true) {
          try {
            const saveResponse = await saveTransaction(purchase)
            purchase.orderNumber =
              saveResponse.data?.id ||
              saveResponse.data?.autorizacao ||
              purchase.autorizacao
          } catch (error) {
            console.error('Pinpad OK, falha ao gravar no portal:', error.response?.data || error)
            openSupportTask('Erro ao gravar transação no portal', error)
            // NÃO redireciona para rejeitada
          }

          this.$store.dispatch('setReceipt', purchase)
          this.$router.push('/debito/pagamento-debito-veicular-sucesso')
        } else if (purchase.sucesso === false) {
          this.$store.dispatch('setReceipt', purchase)
          this.$router.push('/debito/pagamento-debito-veicular-rejeitada')
        } else {
          this.$router.push('/home')
        }
      } catch (error) {
        openSupportTask('Erro ao efetuar pagamento no Pinpad', error)
        router.push('/home')
      }
    } catch (e) {
      console.error('Erro geral no pagamento:', e)
      router.push('/home')
    }
  },
  methods: {
    async cadastrarDebitoVeicular(purchase) {
      const debitosSelecionados = JSON.parse(
        sessionStorage.getItem('debitosSelecionados') || '[]',
      )
      const dadosPessoais = JSON.parse(
        sessionStorage.getItem('dadosPessoais') || '{}',
      )
      const clienteNome = sessionStorage.getItem('clienteNome') || ''
      const placa = sessionStorage.getItem('placaVeiculo') || ''
      const renavam = sessionStorage.getItem('renavamDigitado') || ''
      const estado = sessionStorage.getItem('clienteVeiculo') || ''

      const payloadDebito = {
        idMovimentacao: purchase.orderNumber,
        telefone: dadosPessoais.phone,
        placa,
        renavam,
        estado,
        proprietario: clienteNome,
        proprietarioDocumento: dadosPessoais.cpf,
        debitos: debitosSelecionados,
      }

      try {
        const response = await axios.post(
          'https://appws.feelbank.com.br/cdx/totem/cadastrarDebitoVeicular',
          payloadDebito,
          {
            headers: {
              AdgToken:
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIxMTI4IiwibG9naW4iOiJ0aUBmaXJzdHBhZy5jb20uYnIiLCJlbWFpbCI6InRpQGZpcnN0cGFnLmNvbS5iciJ9.CVb4rWw9Jofht8fFcRtG3hIKYW6_hP7ja3-4toaRQp8',
              'Content-Type': 'application/json',
            },
          },
        )

        if (response.status === 200) {
          console.log('Débitos registrados com sucesso.')
        } else {
          console.log('Falha ao registrar débitos. Resposta:', response.data)
        }
      } catch (error) {
        console.error('Erro ao enviar débitos:', error)
      }
    },
  },
})
</script>